// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2cGeB","buttons":"PendingPaymentAlert_buttons__3SK_o"};